import cirxConfig from "@/core/config/cirxConfig";
import { isDashboardApp } from "@/core/services/domain.service";
import { MULTI_PRODUCT_CART } from "@/core/models/enums/premiumFeatures.enum";
import useOrganizationRootDetailsStore from "@/core/store/organizationRootDetailsStore";
import { Cart } from "@/apps/shared/buyback/core/domain/model/Cart";
import { BuybackSettingsRepositoryInterface } from "@/apps/shared/buyback/core/domain/service/interface/BuybackSettingsRepositoryInterface";
import ICartRepository from "@/apps/shared/buyback/core/domain/service/interface/ICartRepository";

const getMaxNbOfItems = (): number => {
  const { isThisFeatureEnabled } = useOrganizationRootDetailsStore();
  const isMultiProductEnabled = isThisFeatureEnabled(MULTI_PRODUCT_CART);

  return isMultiProductEnabled ? cirxConfig.cart.maxNbOfItems : 1;
};

const isCartExpired = (storedAt: number): boolean => {
  const cartTimeToLiveInDays = isDashboardApp()
    ? cirxConfig.cart.timeToLiveInDays.inDashboardApp
    : cirxConfig.cart.timeToLiveInDays.inPublicApp;

  return storedAt + 86400 * cartTimeToLiveInDays < new Date().getTime();
};

const getInitialCart = async (
  buybackSettingsRepository: BuybackSettingsRepositoryInterface,
  cartRepository: ICartRepository
): Promise<Cart> => {
  const buybackSettings = await buybackSettingsRepository.get();
  const minimumCartValue = buybackSettings.getMinimumCartValueAsDecimal();
  const maxNbOfItems = getMaxNbOfItems();

  const cartStoredAt = cartRepository.getStoredAt();

  return cartStoredAt === null || isCartExpired(cartStoredAt)
    ? new Cart([], maxNbOfItems, minimumCartValue)
    : cartRepository.getCart(minimumCartValue, maxNbOfItems);
};

export default {
  getInitialCart,
};
